import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
export class UploadedDocumentResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.documentId = undefined;
        this.filename = "";
        this.documentType = "";
        this.documentTypeDisplayname = "";
        this.mustSign = false;
        this.archived = false;
        this.documentURL = "";
        this.canBeDeleted = false;
    }
    pk() {
        return this.documentId?.toString();
    }
}
UploadedDocumentResource.urlRoot = legacyApiResourceUrl("DocumentGrid/GetUploadedDocumentList");
//# sourceMappingURL=UploadedDocumentResource.js.map